import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  background: ${(p) => p.theme.palette.common.white};
  margin-top: ${(p) => p.theme.spacing(3)};
  padding: ${(p) => p.theme.spacing(1)};
  border-radius: ${(p) => p.theme.spacing(1)};
`;
